<template>
	<div class="my-3 my-md-5">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header justify-content-between">
							<h3 class="card-title">Doc Details</h3>
							<button type="button" class="btn btn-sm btn-outline-primary text-uppercase" data-toggle="modal" data-target="#detailsModal" @click="openAddModal"><i class="fe fe-plus d-block" title="Add New"></i></button>
						</div>
						<div class="table-responsive">
							<table class="table table-hover table-outline table-vcenter text-nowrap card-table">
								<thead>
									<tr>
										<th class="text-center">Sr. No.</th>
										<th>Property</th>
										<th>Title</th>
										<th>URL</th>
										<th class="text-center">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="dataArray.length == 0">
										<td colspan="8" class="text-center">No data available</td>
									</tr>
									<tr v-else v-for="(data, index) in dataArray" :key="data._id">
										<td>
											<div class="text-center">
												{{ index+1 }}
											</div>
										</td>
										<td>
											<div>
												{{ data.property }}
											</div>
										</td>
										<td>
											<div>
												{{ data.title }}
											</div>
										</td>
										<td>
											<div>
												<a :href="data.url" target="_blank">View Online</a>
											</div>
										</td>
										<td class="text-center">
											<button type="button" class="btn btn-sm btn-default" title="Edit" @click="openEditModal(data)"><i class="fe fe-edit"></i></button>
											<button type="button" class="btn btn-sm btn-default ml-1" title="Delete" @click="openDeleteModal(data._id)"><i class="fe fe-trash"></i></button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Add / Edit Modal -->
		<div class="modal fade" id="detailsModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<form id="dash-form" class="modal-content" @submit.prevent="submitDetailsForm">
					<div class="modal-header">
						<template v-if="modalTypeEdit">
							<h5 class="modal-title" id="exampleModalLabel">Edit Details</h5>
						</template>
						<template v-else>
							<h5 class="modal-title" id="exampleModalLabel">Add Details</h5>
						</template>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="row m-0">
							<div class="col-md-12">
								<div class="form-group alert alert-danger" role="alert">
									Woops! Something Went Wrong, Please Try Again.
								</div>  
							</div>
							<div class="col-md-6">
								<TextField :data="formData.property" name="property" label="Property" :required="true" v-bind:value.sync="formData.property"/>
							</div>
							<div class="col-md-6">
								<TextField :data="formData.title" name="title" label="Title" :required="true" v-bind:value.sync="formData.title"/>
							</div>
							<div class="col-md-12">
								<TextField :data="formData.url" name="url" label="URL" :required="true" v-bind:value.sync="formData.url"/>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="reset" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="submit" id="submit" class="btn btn-primary ml-2 text-uppercase">Sumbit</button>
					</div>
				</form>
			</div>
		</div>
		<!-- Delete Modal -->
		<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Confirm Delete</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						Delete this Data?
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-primary" @click="confirmDelete">Confirm</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import TextField from '@/components/form/TextField.vue'

export default {
	name: 'Docs',
	components: {
		TextField
	},
	data() {
		return {
			modalTypeEdit: false,
			formData: {
				property: '',
				title: '',
				url: ''
			},
			dataId: '',
			dataArray: []
		}
	},
	mounted() {
		// Hide loader
		this.$store.dispatch('setLoading', false);
		/* global $ */
		let self = this;
		// Reset Form On Modal Hide
		$('#detailsModal').on('hidden.bs.modal', function () {
			self.resetFormData();
		});
		// Reset Delete Id On Modal Hide
		$('#deleteModal').on('hidden.bs.modal', function () {
			self.deleteId = '';
		});
		// Dummy Data
		/*this.dataArray = [
		{
			id: '001',
			property: '.store',
			title: 'Devs Requirement Guide',
			url: 'https://docs.google.com/spreadsheets/d/1tHY4pvI4WwD780Fw8dPIj_1Df5m31ZwML5iWUpntDlU/edit?usp=sharing'
		},
		{
			id: '002',
			property: '.tech',
			title: 'Devs Requirement Guide',
			url: 'https://docs.google.com/spreadsheets/d/1tHY4pvI4WwD780Fw8dPIj_1Df5m31ZwML5iWUpntDlU/edit?usp=sharing'
		},
		{
			id: '003',
			property: '.space',
			title: 'Devs Requirement Guide',
			url: 'https://docs.google.com/spreadsheets/d/1tHY4pvI4WwD780Fw8dPIj_1Df5m31ZwML5iWUpntDlU/edit?usp=sharing'
		},
		{
			id: '004',
			property: '.online',
			title: 'Devs Requirement Guide',
			url: 'https://docs.google.com/spreadsheets/d/1tHY4pvI4WwD780Fw8dPIj_1Df5m31ZwML5iWUpntDlU/edit?usp=sharing'
		},
		{
			id: '005',
			property: '.site',
			title: 'Devs Requirement Guide',
			url: 'https://docs.google.com/spreadsheets/d/1tHY4pvI4WwD780Fw8dPIj_1Df5m31ZwML5iWUpntDlU/edit?usp=sharing'
		}
		]*/
	    // Get Docs Listing
	    this.getData('docs-details', self.dataArray);
	},
	beforeDestroy() {
		/* global $ */
		let self = this;
		// Unsubscribe Docs listing data
	    this.getData('docs-details', self.dataArray, 'unsubscribe');
	},
	methods: {
		submitDetailsForm: function() {
			let self = this;
			// Check Vee Validate
			self.$validator.validateAll().then((result) => {
				if (result) {
					// Add / Edit Docs Data
					if(self.modalTypeEdit == true) {
						self.sendData('docs-details', self.formData, self.dataId);
					}
					else {
						self.sendData('docs-details', self.formData);
					}
					return;
				}
			});
		},
		confirmDelete: function() {
			// Delete Docs Data
			this.deleteData('docs-details', this.dataId);
		},
		resetFormData: function() {
			this.modalTypeEdit = false;
			this.dataId = '';
			// Prefill Edit Values
			this.formData.property = '';
			this.formData.title = '';
			this.formData.url = '';
			// Emit Reset Event
			this.$root.$emit('reset-validation');
		},
		openAddModal: function() {
			this.modalTypeEdit = false;
			// Show Modals
			$('#detailsModal').modal('show');
		},
		openEditModal: function(obj) {
			this.modalTypeEdit = true;
			// Prefill Edit Values
			this.dataId = obj._id;
			this.formData.property = obj.property;
			this.formData.title = obj.title;
			this.formData.url = obj.url;
			// Show Modal
			$('#detailsModal').modal('show');
		},
		openDeleteModal: function(id) {
			this.dataId = id;
			// Show Modal
			$('#deleteModal').modal('show');
		}
	}
}
</script>
